module.exports = __webpack_public_path__ + "static/media/signup-banner.ca0f4bf2.png";